import { createAction, props } from '@ngrx/store';
import { FieldActivity } from '../_models';

// Action types
export const loadFieldActivities = createAction(
  '[FieldActivity] Load FieldActivities',
  props<{ selectedYear?: number }>()
);
export const loadFieldActivitiesSuccess = createAction(
  '[FieldActivity] Load FieldActivities Success',
  props<{ fieldActivities: FieldActivity[] }>()
);
export const loadFieldActivitiesFailure = createAction(
  '[FieldActivity] Load FieldActivities Failure',
  props<{ error: any }>()
);

export const addFieldActivity = createAction(
  '[FieldActivity] Add FieldActivity',
  props<{ fieldActivity: FieldActivity }>()
);
export const addFieldActivitySuccess = createAction(
  '[FieldActivity] Add FieldActivity Success',
  props<{ fieldActivity: FieldActivity }>()
);
export const addFieldActivityFailure = createAction(
  '[FieldActivity] Add FieldActivity Failure',
  props<{ error: any }>()
);

export const updateFieldActivity = createAction(
  '[FieldActivity] Update FieldActivity',
  props<{ fieldActivity: FieldActivity }>()
);
export const updateFieldActivitySuccess = createAction(
  '[FieldActivity] Update FieldActivity Success',
  props<{ fieldActivity: FieldActivity }>()
);
export const updateFieldActivityFailure = createAction(
  '[FieldActivity] Update FieldActivity Failure',
  props<{ error: any }>()
);

export const deleteFieldActivity = createAction(
  '[FieldActivity] Delete FieldActivity',
  props<{ id: number }>()
);
export const deleteFieldActivitySuccess = createAction(
  '[FieldActivity] Delete FieldActivity Success',
  props<{ id: number }>()
);
export const deleteFieldActivityFailure = createAction(
  '[FieldActivity] Delete FieldActivity Failure',
  props<{ error: any }>()
);

export const getFieldActivity = createAction(
  '[FieldActivity] Get FieldActivity',
  props<{ id: number }>()
);
export const getFieldActivitySuccess = createAction(
  '[FieldActivity] Get FieldActivity Success',
  props<{ fieldActivity: FieldActivity }>()
);
export const getFieldActivityFailure = createAction(
  '[FieldActivity] Get FieldActivity Failure',
  props<{ error: any }>()
);
